import * as swcHelpers from '@swc/helpers';
import { DataLayer } from '@grandvisionhq/analytics';
import { mapProductListingToDataLayerProductObject } from '../Mappers/ProductListingMapper.js';

const createImpressionEvent = (product, position, location, currency)=>{
    return {
        event: 'gvProductImpressions',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currency,
                impressions: [
                    swcHelpers.objectSpread({}, mapProductListingToDataLayerProductObject(DataLayer.DataLayerTypes.PurchaseType.OneTime, product, product.masterVariant.sku || 'undefined'), {
                        list: location,
                        position
                    }), 
                ]
            }
        }
    };
};

export { createImpressionEvent };
//# sourceMappingURL=ProductBannerEvents.js.map
